// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching the overall theme */
.elder-group-details-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === MAIN CONTENT === */
.details-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === SUMMARY CARDS GRID === */
.summary-cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 1.5rem;
}

.elder-summary-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.summary-title {
    font-size: 1.3rem;
    color: #1e293b;
    font-weight: 700;
    margin: 0 0 1.25rem 0;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #f1f5f9;
}

.summary-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.25rem 0;
}

.item-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #475569;
    font-size: 1.05rem;
    font-weight: 500;
}

.item-value {
    font-size: 1.1rem;
    color: #1e293b;
    font-weight: 600;
}

/* Highlight Boxes inside Status Card */
.alert-box {
    background: #fef2f2;
    padding: 0.75rem;
    border-radius: 8px;
    border-left: 4px solid #ef4444;
}

.success-box {
    background: #f0fdf4;
    padding: 0.75rem;
    border-radius: 8px;
    border-left: 4px solid #10b981;
}

/* Color utilities */
.text-green {
    color: #059669;
}

.text-red {
    color: #dc2626;
}

.text-gray {
    color: #94a3b8;
}

.text-blue {
    color: #2563eb;
}

.text-dark {
    color: #1e293b;
}

.font-bold {
    font-weight: 800;
}

.elder-divider {
    height: 1px;
    background: #cbd5e1;
    margin: 2.5rem 0;
}

/* === LISTS / STRIP CARDS === */
.elder-section {
    margin-bottom: 2rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin-bottom: 1rem;
    padding-left: 0.25rem;
}

.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.elder-strip-card {
    background: white;
    border-radius: 12px;
    padding: 1rem 1.25rem;
    border: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.strip-left {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.icon-circle {
    height: 44px;
    width: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    flex-shrink: 0;
}

.bg-blue {
    background: #3b82f6;
}

.bg-green {
    background: #10b981;
}

.bg-gray {
    background: #94a3b8;
}

.strip-info {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

.strip-title {
    margin: 0;
    font-size: 1.1rem;
    color: #1e293b;
    font-weight: 600;
}

.strip-subtitle {
    font-size: 0.9rem;
    color: #64748b;
}

.strip-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.35rem;
}

.text-right {
    text-align: right;
}

.strip-amount {
    font-size: 1.2rem;
    font-weight: 700;
}

.status-badge {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-success {
    background: #dcfce7;
    color: #15803d;
}

.badge-warning {
    background: #fef3c7;
    color: #b45309;
}

.elder-empty-box {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    text-align: center;
    font-size: 1.1rem;
    color: #94a3b8;
    border: 1px dashed #cbd5e1;
}

/* === MOBILE RESPONSIVE === */
@media (max-width: 768px) {
    .details-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .summary-cards-grid {
        grid-template-columns: 1fr;
    }

    .elder-strip-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .strip-right {
        width: 100%;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #f1f5f9;
        padding-top: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/member/GroupDetails.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,2DAA2D;IAC3D,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA,oBAAoB;AACpB;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;AAC9B;;AAEA,8BAA8B;AAC9B;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,6BAA6B;QAC7B,oBAAoB;IACxB;AACJ","sourcesContent":["/* Container matching the overall theme */\n.elder-group-details-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === MAIN CONTENT === */\n.details-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1000px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === SUMMARY CARDS GRID === */\n.summary-cards-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n    gap: 1.5rem;\n}\n\n.elder-summary-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.summary-title {\n    font-size: 1.3rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin: 0 0 1.25rem 0;\n    padding-bottom: 0.75rem;\n    border-bottom: 2px solid #f1f5f9;\n}\n\n.summary-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.summary-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.25rem 0;\n}\n\n.item-label {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    color: #475569;\n    font-size: 1.05rem;\n    font-weight: 500;\n}\n\n.item-value {\n    font-size: 1.1rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n/* Highlight Boxes inside Status Card */\n.alert-box {\n    background: #fef2f2;\n    padding: 0.75rem;\n    border-radius: 8px;\n    border-left: 4px solid #ef4444;\n}\n\n.success-box {\n    background: #f0fdf4;\n    padding: 0.75rem;\n    border-radius: 8px;\n    border-left: 4px solid #10b981;\n}\n\n/* Color utilities */\n.text-green {\n    color: #059669;\n}\n\n.text-red {\n    color: #dc2626;\n}\n\n.text-gray {\n    color: #94a3b8;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.text-dark {\n    color: #1e293b;\n}\n\n.font-bold {\n    font-weight: 800;\n}\n\n.elder-divider {\n    height: 1px;\n    background: #cbd5e1;\n    margin: 2.5rem 0;\n}\n\n/* === LISTS / STRIP CARDS === */\n.elder-section {\n    margin-bottom: 2rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin-bottom: 1rem;\n    padding-left: 0.25rem;\n}\n\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.elder-strip-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1rem 1.25rem;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.strip-left {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n.icon-circle {\n    height: 44px;\n    width: 44px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    flex-shrink: 0;\n}\n\n.bg-blue {\n    background: #3b82f6;\n}\n\n.bg-green {\n    background: #10b981;\n}\n\n.bg-gray {\n    background: #94a3b8;\n}\n\n.strip-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n}\n\n.strip-title {\n    margin: 0;\n    font-size: 1.1rem;\n    color: #1e293b;\n    font-weight: 600;\n}\n\n.strip-subtitle {\n    font-size: 0.9rem;\n    color: #64748b;\n}\n\n.strip-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.35rem;\n}\n\n.text-right {\n    text-align: right;\n}\n\n.strip-amount {\n    font-size: 1.2rem;\n    font-weight: 700;\n}\n\n.status-badge {\n    font-size: 0.75rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.badge-success {\n    background: #dcfce7;\n    color: #15803d;\n}\n\n.badge-warning {\n    background: #fef3c7;\n    color: #b45309;\n}\n\n.elder-empty-box {\n    background: white;\n    border-radius: 12px;\n    padding: 2rem;\n    text-align: center;\n    font-size: 1.1rem;\n    color: #94a3b8;\n    border: 1px dashed #cbd5e1;\n}\n\n/* === MOBILE RESPONSIVE === */\n@media (max-width: 768px) {\n    .details-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .summary-cards-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .elder-strip-card {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .strip-right {\n        width: 100%;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
